const retailerMap = {
  //url: 'https://api.kattnakken.no/retailers?pagination=false',
  //url: 'https://strapi.kattnakken.no/api/retailers?pagination[pageSize]=500&populate=openinghours&filters[active][$eq]=true',
  url: "https://api.kattnakken.no/api/retailers?pagination[pageSize]=500&populate=openinghours&filters[active][$eq]=true",
  bounds: [],
  filterInput: document.querySelector("#filterInput"),
  list: document.querySelector("#retailer-list"),
  map: null,
  markerCluster: null,
  retailers: [],
  markers: [],
  filterValue: "",
  filteredRetailers: [],
  boundsRetailers: [],

  newInit: function () {
    window.location.replace("https://regn.kattnakken.no/butikkar");
  },

  /**
   * Initialize object
   */
  init: async function () {
    retailerMap.map = L.map("map", { closePopupOnClick: false }).setView(
      [59.77384953796976, 5.484728849003525],
      17
    );
    retailerMap.fetchRetailers();

    filterInput.addEventListener("keyup", () => {
      if (retailerMap.filterInput.value === "") {
        retailerMap.filteredRetailers = retailerMap.boundsRetailers;
      } else {
        retailerMap.filteredRetailers = retailerMap.boundsRetailers.filter(
          (retailer) => {
            if (
              retailer.json.zipcode.includes(retailerMap.filterInput.value) ||
              retailer.json.address1
                .toLowerCase()
                .match(retailerMap.filterInput.value.toLowerCase()) ||
              retailer.json.place
                .toLowerCase()
                .match(retailerMap.filterInput.value.toLowerCase()) ||
              retailer.json.title
                .toLowerCase()
                .match(retailerMap.filterInput.value.toLowerCase())
            ) {
              return retailer;
            }
          }
        );
      }
      retailerMap._renderList();
    });
  },

  /**
   * Fetch retailers
   *
   * @returns
   */
  fetchRetailers: async function () {
    const res = await fetch(retailerMap.url, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        //'Preload': '/api/zipcodes/*'
      },
    });

    if (res.ok) {
      // Clear loading spinner
      retailerMap.list.innerHTML = "";

      let retailers = await res.json();
      retailers.data.forEach((retailer) => {
        let marker = retailerMap._createMarker(retailer.attributes);
        let htmlElement = retailerMap._createRetailerListItem(
          retailer.attributes
        );

        htmlElement.addEventListener("click", () => {
          if (retailer.webOnly) {
            window.open("https://" + retailer.attributes.website, "_blank");
          } else {
            retailerMap.map.setView(
              [retailer.attributes.latitude, retailer.attributes.longitude],
              17
            );
            retailerMap.retailers.forEach((marker) => {
              if (retailer.attributes.title === marker.marker.options.title) {
                marker.marker.openPopup();
              }
            });
          }
        });

        // Add marker and html element to retailers array
        retailerMap.retailers.push({
          marker: marker,
          html: htmlElement,
          json: retailer.attributes,
        });

        // Push html element to list element
        retailerMap.list.append(htmlElement);

        // Also push latitude and longitude to bounds array
        retailerMap.bounds.push([
          retailer.attributes.latitude,
          retailer.attributes.longitude,
        ]);
      });

      retailerMap.boundsRetailers = retailerMap.retailers;

      // Ok, everything is created, time to render map
      retailerMap._renderMap();
    }

    return false;
  },

  _renderMap: function () {
    // Add markers
    retailerMap.retailers.forEach((retailer) => {
      retailer.marker.addTo(retailerMap.map);
    });

    // Add tiles
    let tileUrl = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
    L.tileLayer(tileUrl, {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 18,
      tileSize: 256,
    }).addTo(retailerMap.map);
    retailerMap.map.scrollWheelZoom.disable();
    retailerMap.map.fitBounds(retailerMap.bounds, { padding: [100, 100] });
    retailerMap.map.on("moveend", function () {
      retailerMap.filteredRetailers = retailerMap.boundsRetailers =
        retailerMap.retailers.filter(function (retailer) {
          return retailerMap.map
            .getBounds()
            .contains(
              L.latLng(retailer.json.latitude, retailer.json.longitude)
            );
        });
      retailerMap._renderList();
    });
  },

  _renderList: function () {
    retailerMap.list.innerHTML = "";
    retailerMap.filteredRetailers.forEach((retailer) => {
      retailerMap.list.append(retailer.html);
    });
  },

  _createRetailerListItem: function (retailer) {
    let html = `<h3 class="mb-1 flex items-center">`;

    if (!retailer.webOnly) {
      html += `
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        `;
    }

    html += `
        ${retailer.title}</h3>
        <p class="mb-1">${retailer.address1}</p>
        <p class="mb-1">${retailer.zipcode} ${retailer.place}</p>
      `;

    if (retailer.website && retailer.website !== "null") {
      html += `<p class="mb-1">${retailer.website}</p>`;
    }

    let li = document.createElement("li");
    li.classList.add("border-b");

    let a = document.createElement("a");
    a.classList.add("p-4", "block");
    a.innerHTML = html;

    li.append(a);

    return li;
  },

  _createMarker: function (retailer) {
    let KattnakkenIcon = L.Icon.extend({
      options: {
        iconUrl: KattnakkenMarkerIcon,
        iconSize: [25, 41],
        iconAnchor: [12, 40],
        popupAnchor: [0, -42],
      },
    });

    let location = new L.LatLng(retailer.latitude, retailer.longitude);
    let marker = L.marker(location, {
      title: retailer.title,
      icon: new KattnakkenIcon(),
    });
    marker.bindPopup(retailerMap.__createPopupContent(retailer));
    //markerCluster.addLayer(marker);
    return marker;
  },

  __createPopupContent: function (retailer) {
    let content = `
        <h3 class="my-1 text-md text-green-dark font-bold">${retailer.title}</h3>
        <span class="block my-1">
          ${retailer.address1}<br>
          ${retailer.zipcode} ${retailer.place}<br>
        </span>
      `;
    if (retailer.openinghours) {
      content += `<h4 class="my-1 text-green-dark">Opningstider</h4>`;
      retailer.openinghours.forEach((openinghour) => {
        content += `<span class="block my-1">${
          openinghour.Day
        } ${openinghour.Opening.substring(
          0,
          5
        )} - ${openinghour.Closing.substring(0, 5)}</span>`;
      });
    }
    if (retailer.website && retailer.website !== "null") {
      content += `<a class="block my-1" href="https://${retailer.website}" target="_blank">${retailer.website}</a>`;
    }

    return content;
  },

  findUniqueCounties: function () {
    const exist = {};
    const unique = [];
    retailerMap.retailers.forEach((element) => {
      if (!exist[element.zipcode.county.number]) {
        exist[element.zipcode.county.number] = true;
        unique.push(element.zipcode.county);
      }
    });
    unique.sort(function (a, b) {
      // Sort by name
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    return unique;
  },
};

(function () {
  "use strict";
  retailerMap.newInit();
  //retailerMap.init();
})();
